<template lang="pug" xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  div(v-cloak)
    v-btn(text icon small @click.stop="openDialog" color="white" class="" v-if="!hideSearchBtn")
      v-icon search
    v-dialog(persistent v-model="dialog" :max-width="showProducts && onContact ? '1264px' : '960px'" scrollable no-click-animation)
      v-card
        v-card-title.app-append.white--text
          span {{$t('stock.stock_search.title')}}
          v-spacer
          v-btn(color="white" text small icon @click.stop="closeDialog")
            v-icon close
        v-card-text(:class="{'padding-has-products': showProducts && onContact}")
          v-row(wrap)
            v-flex(sm4 class="nav-contact-product" v-if="showProducts && onContact")
              v-flex(xs12 class="overflow-auto")
                v-app-bar(flat absolute dense class="background-color-eee")
                  v-toolbar(flat dense class="background-color-eee")
                    v-layout(row wrap)
                      v-flex(sm9) FM確定商品
                      v-flex(style="text-align: right") 割当済
                v-sheet(max-height="700" class="overflow-auto sheet-class")
                  v-container(class="container-nav-contact-product")
                    v-list-item-group(v-model="listItemProducts" color="primary" active-class="border-active-list" mandatory)
                      v-list-item(v-for="product, index in contactProducts", :key="index", @click.stop="triggerFillSearchStock(index)")
                        v-flex(style="width: 85%;")
                          v-list-item-title {{(product['variety'] && product['variety']['item']) ? product['variety']['item']['name'] : product['item_input']}} {{product['variety'] ? product['variety']['name'] : product['variety_input']}} {{product['size'] ? formatSizeToDisplay(product['size']['name']) : formatSizeToDisplay(product['size_input'])}}
                          v-list-item-subtitle {{product['note']}}
                        v-flex.align-center
                          v-switch(
                            @click.stop="doAllocated(product)"
                            :input-value="product['is_allocated']"
                          )
                          v-dialog(no-click-animation persistent v-model="showDialogConfirm" max-width=400)
                            v-card
                              v-card-title.app-edit.white--text {{$t('confirmation')}}
                              v-card-text test confirm allocate
                              v-card-actions
                                v-spacer
                                v-btn(@click.stop="doAllocated(product)") {{$t('ok')}}
                                v-btn(@click.stop="showDialogConfirm = false") {{$t('cancel')}}
            v-flex(:class="showProducts && onContact ? 'sm8' : ''" style="max-height: 700px;")
              v-row.margin-8(wrap)
                v-flex(xs12 sm6)
                  v-text-field(
                    :label="$t('stock.stock_search.keyword')+'*'"
                    type="text"
                    :rules="[rules.required]"
                    v-model="search.keyword"
                    prepend-icon="search"
                    ref="keyword"
                    clearable
                    em="stocksearch.1"
                  )
                v-flex(xs12 sm6)
                  v-autocomplete(
                    :items="customers"
                    :label="$t('stock.stock_search.customer')"
                    item-text="name"
                    item-value="id"
                    v-model="search.customer"
                    return-object
                    ref="customer"
                    prepend-icon="person"
                    clearable
                    :rules="isRequiredInputCustomer ? [rules.required] : []"
                    em="stocksearch.2"
                  )
                v-flex(xs12 sm6)
                  v-text-field(
                    type="text"
                    :label="$t('stock.stock_search.auction_date')"
                    v-model="search.auction_date"
                    ref="auction_date"
                    @keydown.enter="search.auction_date = pickDate(search.auction_date)"
                    prepend-icon="event"
                    clearable
                    hide-details
                    em="stocksearch.3"
                  )
                v-flex(xs12 sm6)
                  v-autocomplete(
                    :items="suppliers"
                    :label="$t('stock.stock_search.supplier')"
                    item-text="name"
                    item-value="id"
                    v-model="search.supplier"
                    return-object
                    ref="supplier"
                    prepend-icon="fa-address-book"
                    validate-on-blur
                    clearable
                    hide-details
                    em="stocksearch.4"
                  )
              v-layout.search-button
                v-flex
                  v-btn(
                    color="pink white--text"
                    @click.stop="searchStock"
                  )
                    v-icon search
                    span {{ $t('search') }}
              v-data-table.table-stock-sale(
                :headers="headers"
                :items="stocks"
                item-key="unique_key"
                :footer-props="{'items-per-page-options': [5, 15, 30, 50]}"
                :items-per-page="50"
                :expanded="expanded"
                :options.sync="pagination"
              )
                template(v-slot:item.status_name="{ item }")
                  td(v-if="!item.hideInfo" :class="{'text-red': item.status_id == 1, 'text-green': item.status_id == 2, 'text-yellow': item.status_id == 3}").width-25.no-border-bottom {{ item.status_name }}
                template(v-slot:item.auction_date="{ item }")
                  td(v-if="!item.hideInfo").no-border-bottom {{ item.auction_date | date('MM月DD日') }}
                    span(v-if="item.auction_date") ({{ getDayOfWeekJapanese(item.auction_date) }})
                template(v-slot:item.supplier_name="{ item }")
                  td(v-if="!item.hideInfo").small-name.no-border-bottom {{item.supplier_name}}
                template(v-slot:item.product="{ item }")
                  td(v-if="!item.hideInfo" width='20%').name-product.small-name.no-border-bottom {{item.product}}
                template(v-slot:item.size_name="{ item }")
                  td(v-if="!item.hideInfo").no-border-bottom {{item.size_name}}
                template(v-slot:item.customer="{ item }")
                  td(v-if="!item.hideInfo").no-border-bottom {{item.customer}}
                template(v-slot:item.quantity="{ item }")
                  td.no-border-bottom(v-if="!item.hideInfo") {{item.quantity}}
                template(v-slot:item.remaining_boxes="{ item }")
                  td(v-if="!item.hideInfo" width='20%').name-product.no-border-bottom.align-center {{ item.total_sold_boxes ? item.total_sold_boxes : 0 }} / {{ item.boxes - item.total_sold_boxes }}
                template(v-slot:item.lot="{ item }")
                  td.no-border-bottom {{item.lot}}
                template(v-slot:item.price="{ item }")
                  td.no-border-bottom(:class="item.price === '--' ? 'text-red' : ''") {{item.price}}
                template(v-slot:item.box_sell="{ item }")
                  td.input-box-sell.no-border-bottom
                    v-text-field(
                      type="text"
                      v-model="item.box_sell"
                      solo
                      hide-details
                      ref="box_sell"
                      :disabled="checkNotAllowToAddOrder(item.status_id, item.uuid, item.price)"
                      :solo-inverted="checkNotAllowToAddOrder(item.status_id, item.uuid)"
                      @keypress="preventNonNumericalInput($event)"
                      @input="stockHasInputBox(item)"
                      class="disabled-ime-mode-v-text-field"
                    )
                template(v-slot:top="")
                  div(class="text-center font-weight-bold") {{$t('stock.stock_result_table.result_description')}}
                template(v-slot:expanded-item="{ headers, item }")
                  td(:colspan="headers.length")
                    v-row(justify="center" align="center")
                      v-col(cols="6" sm="6")
                      v-col.decrease-padding(cols="3" sm="3")
                        v-text-field.input-price.nospin(
                          type="number"
                          v-model="item.input_price"
                          solo
                          :label="$t('stock.stock_result_table.price')"
                          ref="price"
                          prefix="@"
                          :rules="!item.price ? [rules.required] : []"
                          hide-details
                          @keypress="preventNonNumericalInput($event)"
                          min="1"
                          validate-on-blur
                        )
                      v-col.decrease-padding(cols="3" sm="3")
                        v-text-field.input-buyer-info(
                          type="text"
                          v-model="item.buyer_info"
                          solo
                          :label="$t('stock.stock_result_table.buyer_info')"
                          ref="buyer_info"
                          prefix="#"
                          :rules="isRequiredInputCustomer ? [rules.required] : []"
                          :class="!item.buyer_info ? 'text-red' : ''"
                          hide-details
                          class="disabled-ime-mode-v-text-field"
                          validate-on-blur
                        )
        v-card-actions(style="border-top: 1px solid #eee;")
          v-spacer
          div(class="my-2")
            v-btn.button-save(color="success" @click.stop="saveStockToChart")
              v-icon save
              span.text-save &nbsp;{{$t('stock.stock_result_table.order')}}
</template>

<script>
import rules from '@/common/mixins/rules'
import Entermove from '@/common/mixins/entermove'
import datepick from '@/common/mixins/datepick'
import utils from '@/app/mixins/utils'
import { mapGetters } from 'vuex'
export default {
  data () {
    return {
      dialog: false,
      expanded: [],
      rowsPerPageItems: [5, 15, 30, 50, {'text': '$vuetify.dataIterator.rowsPerPageAll', 'value': -1}],
      pagination: {
        rowsPerPage: 50
      },
      options: {
        itemsPerPageOptions: 15
      },
      customers: [],
      suppliers: [],
      search: {
        keyword: null,
        auctionDate: null,
        customer: null,
        supplierId: null
      },
      chartDetails: [],
      stocks: [],
      stocksChangeList: [],
      contactProducts: [],
      showProducts: false,
      listItemProducts: null,
      contactProductSelected: null,
      isRequiredInputCustomer: false,
      prevStockHash: '',
      prevChartId: '',
      showDialogConfirm: false,
      headers: [
        {
          text: this.$t('stock.stock_result_table.status'),
          value: 'status_name',
          align: 'center'
        },
        {
          text: this.$t('stock.stock_result_table.auction_date'),
          value: 'auction_date',
          align: 'center'
        },
        {
          text: this.$t('stock.stock_result_table.supplier'),
          value: 'supplier_name',
          align: 'center'
        },
        {
          text: this.$t('stock.stock_result_table.product'),
          value: 'product',
          align: 'center'
        },
        {
          text: this.$t('stock.stock_result_table.size'),
          value: 'size_name',
          align: 'center'
        },
        {
          text: this.$t('stock.stock_result_table.customer'),
          value: 'customer',
          align: 'center'
        },
        {
          text: this.$t('stock.stock_result_table.quantity'),
          value: 'quantity',
          align: 'center'
        },
        {
          text: this.$t('stock.stock_result_table.remaining_boxes'),
          value: 'remaining_boxes',
          align: 'center'
        },
        {
          text: this.$t('stock.stock_result_table.lot'),
          value: 'lot',
          align: 'center'
        },
        {
          text: this.$t('stock.stock_result_table.price'),
          value: 'price',
          align: 'center'
        },
        {
          text: this.$t('stock.stock_result_table.box_sell'),
          value: 'box_sell',
          sortable: false,
          align: 'center'
        }
      ]
    }
  },
  created () {
  },
  props: {
    hideSearchBtn: {
      type: Boolean,
      required: false
    },
    dialogStockSearch: {
      type: Boolean,
      required: false,
      default: false
    },
    dataInfo: {
      type: Object,
      required: false
    },
    onContact: {
      type: Boolean,
      required: true
    }
  },
  watch: {
    dialogStockSearch (newVal, oldVal) {
      if (!oldVal && newVal) {
        this.init()
        this.resetStock()
        this.formatSizeToDisplay()
        this.dialog = true
      }
    },
    pagination: {
      handler (newVal, oldVal) {
        if (newVal !== oldVal) {
          if (['lot', 'price', 'remaining_boxes'].includes(newVal['sortBy'][0])) {
            this.formatParamsGroupByStockHash(this.stocks, true)
          } else {
            this.formatParamsGroupByStockHash(this.stocks)
          }
        }
      },
      deep: true
    }
  },
  mixins: [rules, Entermove, datepick, utils],
  computed: {
    ...mapGetters('common/account', ['isMeLoaded', 'me', 'hasRole'])
  },
  methods: {
    openDialog () {
      this.init()
      this.dialog = true
    },
    stockHasInputBox (item) {
      let index = this.expanded.findIndex((element) => element.id === item.id)
      if (item.box_sell && item.box_sell > 0) {
        // If item not exist in expanded so expand it
        if (index === -1) {
          this.expanded.push(item)
        }
      } else {
        // Need to find index of item got clear input
        if (index > -1) {
          this.expanded.splice(index, 1)
        }
      }
    },
    async init () {
      // Load list customer
      await this.$ajax.get('/customer/list')
        .then((response) => {
          this.customers = response.data
        })
        .catch((messages, error) => {
          messages.map((message) => this.$toastr.error(message))
        })
      // Load list supplier
      await this.$ajax.get('/supplier/list')
        .then((response) => {
          this.suppliers = response.data
        })
        .catch((messages, error) => {
          messages.map((message) => this.$toastr.error(message))
        })
      // get list allocated products
      if (this.dataInfo && this.dataInfo.id) {
        await this.$ajax.get(
          `/contact/contact_products/${this.dataInfo.id}`,
          { loading: false }
        ).then((response) => {
          this.contactProducts = response.data['contact_products']
          this.contactAuctionDate = response.data['auction_date']
          this.contactCustomer = response.data['customer']
          this.showProducts = true
        }).catch((messages, error) => {
          messages.map((message) => this.$toastr.error(message))
        })
      }
    },
    closeDialog () {
      this.dialog = false
      // Only emit event when call dialog stock search not from menu page
      if (this.hideSearchBtn) {
        this.$emit('closeDialogSearch', this.chartDetails)
        this.chartDetails = []
      }
    },
    searchStock () {
      // No need to required input customer in stock search screen
      this.isRequiredInputCustomer = false
      // Uncomment here for save
      this.resetStock()
      if (this.hasRuleError()) {
        this.$toastr.warning(this.$t('common.rules.invalidate_message'))
        return true
      }
      let param = {
        keyword: this.search.keyword ? this.search.keyword : '',
        auction_date: this.search.auction_date ? this.search.auction_date : null,
        customer: this.search.customer ? this.search.customer.fm_customer : null,
        supplier: this.search.supplier ? this.search.supplier.id : null
      }

      this.$ajax.post('/stock/search', param)
        .then(response => {
          let stocks = response.data
          this.formatParamsGroupByStockHash(stocks)
        })
        .catch((messages, error) => {
          messages.map(message => this.$toastr.error(message))
        })
    },
    formatParamsGroupByStockHash (stocks, flex) {
      this.prevStockHash = ''
      this.prevChartId = ''
      stocks.forEach((stock) => {
        if (this.prevStockHash !== stock.stock_hash || this.prevChartId !== stock.chart_id) {
          stock.hideInfo = false
          this.prevStockHash = stock.stock_hash
          this.prevChartId = stock.chart_id
        } else {
          stock.hideInfo = true
        }
        if (flex) {
          stock.hideInfo = false
        }
        return stock
      })
      this.stocks = [...stocks]
    },
    checkNotAllowToAddOrder (status, personInChargeUuid, price) {
      if (price === '--') {
        return true
      }

      if (status === 1) {
        // only Shipment's 担当営業 can add order, other member can not or need confirm Shipment's 担当営業 by call or email
        return this.me.uuid !== personInChargeUuid
      } else {
        return false
      }
    },
    updateStockAfterSave (savedStocks) {
      savedStocks.forEach(savedStock => {
        this.stocks.forEach(stock => {
          if (savedStock.stock === stock.id && savedStock.value) {
            if (stock.total_sold_boxes) {
              stock.total_sold_boxes = parseInt(stock.total_sold_boxes) + parseInt(savedStock.value)
            } else {
              stock.total_sold_boxes = parseInt(savedStock.value)
            }
            if (this.stocksChangeList.indexOf(stock.unique_key) >= 0) {
              stock.box_sell = null
              stock.justSaved = true
            }
            stock.buyer_info = savedStock.buyer
            stock.chart_detail_id = savedStock.id
            // Only emit event when call dialog stock search not from menu page
            if (this.hideSearchBtn) {
              this.chartDetails.push(stock)
            }
          }
        })
      })
      let filterDuplicate = new Set(this.chartDetails)
      this.chartDetails = [...filterDuplicate]
    },
    saveStockToChart () {
      this.isRequiredInputCustomer = true
      if (this.hasRuleError()) {
        this.$toastr.warning(this.$t('common.rules.invalidate_message'))
        return true
      }
      let paramSave = []
      this.stocks.forEach(stock => {
        if (stock.id && stock.box_sell && stock.auction_date && this.search.customer &&
         this.search.customer.id && stock.buyer_info) {
          paramSave.push({
            'buyer': stock.buyer_info,
            'chart': stock.chart_id,
            'chart_category': 1,
            'chart_type': 4,
            'customer': this.search.customer.id,
            'data_key': '',
            'forward': null,
            'histories': [],
            'option': parseInt(stock.option),
            'price': stock.input_price ? parseInt(stock.input_price) : parseInt(stock.price),
            'row_group': 0,
            'size': parseInt(stock.size),
            'split': 0,
            'stock': stock.id,
            'subchart': null,
            'value': parseInt(stock.box_sell),
            'variety': stock.variety,
            'contact_product_id': this.contactProductSelected,
            'version': 1,
            'id': 0
          })
          this.stocksChangeList.push(stock.unique_key)
        }
      })

      if (paramSave && paramSave.length) {
        this.$ajax.post(`/chart/bulk_save`, paramSave).then(response => {
          this.$toastr.success(this.$t('stock.stock_result_table.saved'))
          this.updateStockAfterSave(response.data)
          this.contactProducts.find((value) => {
            if (value.id === this.contactProductSelected) {
              value.is_allocated = true
            }
          })
          this.$emit('updateSuccess')
          // It will reset status of stock after save
          // this.expanded = []
          // this.stocks.forEach(stock => {
          //   stock.input_price = null
          //   stock.buyer_info = null
          // })
        }).catch((messages, error) => {
          messages.map(message => this.$toastr.error(message))
        })
      }
    },
    triggerFillSearchStock (index) {
      this.contactProducts.forEach((product, key) => {
        if (key === index) {
          this.resetStock()
          this.contactProductSelected = product['id']
          this.search.keyword = ((product['variety'] && product['variety']['item']) ? product['variety']['item']['name'] : product['item_input']) + (product['variety'] ? product['variety']['name'] : product['variety_input'])
          this.search.auction_date = this.contactAuctionDate
          this.search.customer = this.customers.find((customer) => customer.id === this.contactCustomer)
          this.search.supplier = this.suppliers.find((supplier) => supplier.id === product['supplier'])
          setTimeout(() => {
            this.searchStock()
          }, 200)
        }
      })
    },
    resetStock () {
      this.stocks = []
      this.prevStockHash = ''
      this.prevChartId = ''
      this.expanded = []
    },
    // 2cm$3号$4輪$5本立
    formatSizeToDisplay (size) {
      if (typeof size !== 'undefined' && size !== null) {
        if (size.includes('$')) {
          let newSize = size.split('$')
          return newSize.join('')
        }
      }
      return size
    },
    doAllocated (product) {
      let params = {
        id: product['id'],
        is_allocated: !product['is_allocated']
      }
      this.$ajax.post('/contact/allocated_contact_product', params, {loading: false})
        .then(() => {
          this.contactProducts.map((pd) => {
            if (pd['id'] === product['id']) {
              pd['is_allocated'] = !pd['is_allocated']
            }
          })
        })
        .catch((messages, error) => {
          messages.map((message) => this.$toastr.error(message))
        })
    }
  }
}
</script>

<style scoped lang="stylus">
.v-dialog > .v-card > .v-card__text {
  padding: 0 24px 0
}
.search-button {
  text-align: center
}

.required label::after {
  content: "*";
}

.text-bold {
  font-weight bolder
}

.table-stock-sale{
  >>>.name-product{
    white-space nowrap
  }

  >>>.small-name {
    font-size: 12px
  }
  >>>table.v-table thead tr{
    height 40px
  }

  >>>.v-data-table__wrapper{
    overflow-x hidden !important
  }

  >>>.v-data-table-header {
    white-space nowrap
  }

  >>>td {
    padding: unset !important
  }

  >>>th {
    padding: unset !important
  }

  >>>.v-data-table__expanded__content {
    -webkit-box-shadow: unset !important
    box-shadow: unset !important
  }

  .decrease-padding {
    padding: 0 !important
    >>>.v-text-field.v-text-field--solo .v-input__control {
      min-height: 36px
    }
    .input-buyer-info {
      width 90%
    }
    .input-price {
      width 90%
    }
  }

  .input-box-sell{
    >>>.v-text-field.v-text-field--solo .v-input__control{
      width: 46px
      font-size: 13px
    }

    >>>.v-text-field.v-text-field--solo .v-input__control{
      min-height: 20px
    }

    >>>.v-input--is-disabled {
      .v-input__slot{
        background-color: silver
      }
    }
  }

  .no-border-bottom {
    border-bottom: unset !important
  }

  .v-data-table__expanded v-data-table__expanded__content {
    box-shadow: inset 0 0 1px 0 rgba(50,50,50,.75), inset 0 0px 2px -2px rgba(50,50,50,.75) !important
  }

  .embed-input{
    >>>.input-price{
      width: 32px
      .v-text-field.v-text-field--solo .v-input__control{
        min-height 20px
      }
      .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) > .v-input__control > .v-input__slot{
        font-size: 14px
      }
    }

    >>>.input-buyer-info{
      .v-text-field.v-text-field--solo .v-input__control{
        min-height 20px
      }
      .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) > .v-input__control > .v-input__slot{
        font-size: 14px
      }
    }

    >>>input[type='number'] {
      -moz-appearance:textfield;
    }
  }

  .text-red{
    color: red
  }

  .text-green{
    color: green
  }

  .text-yellow{
    color: yellow
  }
}

.v-card__actions{
  .text-save{
    margin-top: -2px
  }

  >>>.button-save{
    margin: -8px 8px;
  }
}
.margin-8 {
  margin: 8px !important;
}
.sheet-class{
  padding-top: 48px;
  padding-bottom 40px;
}
.nav-contact-product{
  border-right: 1px solid #eee;
  position: relative;
}
.overflow-auto{
  overflow-x: hidden !important;
}
.background-color-eee {
  background-color: #eee;
}
.container-nav-contact-product{
  padding: 0px !important;
}
.border-active-list {
  border-left: 4px solid #1e88e5;
}
.padding-has-products{
  padding-left: 12px !important;
  padding-right: 12px !important;
}
>>>.v-list-item__icon {
  float: right;
}
>>> .container-nav-contact-product .v-input--selection-controls {
  margin-top: 4px !important;
}
>>> .container-nav-contact-product .v-input--selection-controls .v-input__slot {
  margin-bottom: 0px !important;
}
>>> .table-stock-sale tbody tr {
  height: 40px !important;
}
.width-25{
  width: 25px;
}
>>> .table-stock-sale td {
  height: 40px;
}
/*use for v-text-field*/
.disabled-ime-mode-v-text-field >>> input{
  ime-mode: disabled
}
</style>



// WEBPACK FOOTER //
// src/app/pages/Stock/sale.vue